import { createSlice } from '@reduxjs/toolkit';

import {
	handleAsyncThunkActionState,
	initialAsyncState,
	isAsyncThunkActionWithPrefix
} from '../utils';
import * as thunks from './thunks';

const initialState = {
	fetchPrices: initialAsyncState,
	fetchPayments: initialAsyncState,
	subscribe: initialAsyncState,
	page: 1,
	updatePaymentModal: {
		isOpen: false,
		reactivate: false
	},
	rows: [],
	pagination: {},
	fetchPaymentsByUserId: initialAsyncState
};

const billingSlice = createSlice(
	{
		name: 'billing',
		initialState,
		reducers: {
			clearData() {
				return initialState;
			},
			setCanRegenerateInvoice(state, action) {
				const { rowId, value } = action.payload;
				state.rows[rowId].canRegenerateInvoice = value;
			},
			setPage(state, { payload }) {
				state.page = payload;
			},
			setUpdatePaymentModal(state, { payload = {} }) {
				state.updatePaymentModal = {
					...state.updatePaymentModal,
					...payload
				};
			}
		},
		extraReducers(builder) {
			builder.addCase(
				thunks.fetchPaymentsByUserId.fulfilled,
				(state, action) => {
					Object.assign(state, action.payload);
				}
			);
			builder.addMatcher(
				isAsyncThunkActionWithPrefix('billing'),
				handleAsyncThunkActionState()
			);
		}
	},
	initialState
);

export const {
	clearData,
	setCanRegenerateInvoice,
	setPage,
	setUpdatePaymentModal
} = billingSlice.actions;

export default billingSlice.reducer;
